import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Component from './Component';

const COPIED_MS = 2000;

/**
 * Share the page being read: the native share sheet where the browser has one, a copied link
 * everywhere else.
 */
class ShareButton extends Component {
  state = { copied: false };

  componentWillUnmount = () => {
    clearTimeout(this.timer);
  }

  /** The page's canonical URL, so a link arrived at with tracking parameters is not passed on
   *  still carrying them. */
  url = () => window.location.origin + window.location.pathname;

  share = async () => {
    if (navigator.share) {
      // Rejects when the sheet is dismissed, which is not a failure worth reporting.
      return navigator.share({ title: this.props.title, url: this.url() }).catch(() => {});
    }

    try {
      await navigator.clipboard.writeText(this.url());
      this.setState({ copied: true });
      this.timer = setTimeout(() => this.setState({ copied: false }), COPIED_MS);
    } catch {
      // The clipboard can be refused outright, and there is nothing useful to say if it is.
    }
  }

  render = () => {
    // Neither route available, so the button would do nothing at all.
    if (!navigator.share && !navigator.clipboard) return null;

    const { copied } = this.state;

    return (
      <button className="share-button" onClick={this.share} aria-label="Share this post">
        <FontAwesomeIcon icon={copied ? 'check' : 'share-nodes'} size="lg" />
      </button>
    );
  }
}

export default ShareButton;
